/* System defined core library */
import { Component, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

/* User defined library/components */
import { SelectedExamDetailService } from '../../../scheduling/shared/services/selected-exam-detail.service';


@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss']
})

export class FooterComponent implements OnInit {
  public year: number;

  /* Constructor declaration with required injected services */
  constructor(
    translate: TranslateService,
    private selectedExamDetailService: SelectedExamDetailService,
  ) {
  }

  ngOnInit() {
    this.year = new Date().getFullYear();
  }

  getClass() {
    let programCode = this.selectedExamDetailService.programCode ? this.selectedExamDetailService.programCode.toLowerCase() : '';
    let clientCode = this.selectedExamDetailService.clientCode ? this.selectedExamDetailService.clientCode.toLowerCase() : '';

    return `fixed-bottom footer footer-${programCode} footer-${clientCode}`;
  }
}
